import axios from "axios";

const getBanners = async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${process.env.REACT_APP_BACKEND_URL}/bannerPub/getall`,
      responseType: "json",
      params: {
        deleted: false
      }
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getBanners;
